import { gate } from 'hub-http/gates';
import { createContext, useContext } from 'react';
import { AccessLevelContextProvider } from '../accessLevel/AccessLevelContext';
import AIPropertiesProcessingContextProvider from '../ai/AIPropertiesProcessingContextProvider';
import { AutosaveProvider } from '../autosave/context/AutosaveContext';
import { HighlySensitivePropertyContextProvider } from '../dataSensitivity/HighlySensitivePropertyContextProvider';
import { useGetIsUngated } from '../v2/hooks/useGetIsUngated';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesContext = /*#__PURE__*/createContext(undefined);
export const PropertiesProvider = props => {
  const getIsUngated = useGetIsUngated();
  const isUngatedForSmartProperties = getIsUngated(gate('DataEnrichment:SmartProperties')) && getIsUngated(gate('DataEnrichment:SmartPropertiesStaging'));
  const parentContext = useContext(PropertiesContext);
  if (parentContext !== undefined) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: props.children
    });
  }
  let content = /*#__PURE__*/_jsx(AutosaveProvider, {
    children: /*#__PURE__*/_jsx(HighlySensitivePropertyContextProvider, {
      children: props.children
    })
  });
  const {
    enableFieldLevelPermissions = true
  } = props;
  content = enableFieldLevelPermissions ? /*#__PURE__*/_jsx(AccessLevelContextProvider, {
    children: content
  }) : content;
  content = isUngatedForSmartProperties ? /*#__PURE__*/_jsx(AIPropertiesProcessingContextProvider, {
    children: content
  }) : content;

  // NOTE: `value={true}` is just a marker so that we can tell whether a parent
  // `PropertiesProvider` is present. the marker value could be anything,
  // as long as we can tell it apart from the default `undefined`. In the future
  // if PropertiesContext does something useful this can be replaced with a real value
  return /*#__PURE__*/_jsx(PropertiesContext.Provider, {
    value: true,
    children: content
  });
};